import { toast } from "react-toastify";
import { formResponse, onSuccess, useApiGet, useApiMutation } from "../../utils/api";
import { SimpleForm } from "../../utils/simple_form";
import { useState } from "react";

const UserProfile = () => {
  const { data, unavailable } = useApiGet("/api/user/profile");
  const { post, saving } = useApiMutation();

  if (unavailable) {
    return unavailable;
  }

  const { user } = data;

  const saveProfile = (user) => {
    post("/api/user/update_profile", { user }).then(
      onSuccess(() => toast.success("Profile updated"))
    );
  };

  return (
    <div>
      <h1>Profile</h1>

      <div className="col-12 col-md-4 mt-3">
        <SimpleForm
          fields={{
            first_name: {},
            last_name: {},
          }}
          data={user}
          onSubmit={saveProfile}
          saving={saving}
        />

        <hr />

        <Friends />
      </div>
    </div>
  );
};

export default UserProfile;

const Friends = () => {
  const { data, unavailable, refetch } = useApiGet("/api/user/friends");
  const { post, saving } = useApiMutation();
  const { post: destroy } = useApiMutation();
  const [errors, setErrors] = useState<Record<string, string>>({});

  if (unavailable) {
    return unavailable;
  }

  const { friends } = data;

  const addFriend = ({ email }) => {
    post("/api/user/add_friend", { email }).then(formResponse(refetch, setErrors));
  };

  const removeFriend = (id) => {
    if (confirm("Remove this friend?")) {
      destroy(`/api/user/remove_friend/${id}`).then(onSuccess(refetch));
    }
  };

  return (
    <div>
      <h2>Friends</h2>

      <table className="table table-striped mt-3">
        <thead>
          <tr>
            <td className="fs-12">Name</td>
            <td className="fs-12">Email</td>
            <td />
          </tr>
        </thead>
        <tbody>
          {friends && friends.length > 0 ? (
            friends.map((friend) => (
              <tr key={friend.id}>
                <td>{friend.name || friend.email}</td>
                <td>{friend.email}</td>
                <td className="text-end">
                  <button
                    className="btn btn-text"
                    onClick={() => removeFriend(friend.id)}
                  >
                    <i className="bi bi-x red" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={2} className="text-muted">
                No friends yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <SimpleForm
        className="mt-5"
        fields={{
          email: {
            required: true,
            placeholder: "Email",
            label: "Add friend",
          },
        }}
        data={{}}
        onSubmit={(data) => addFriend(data as any)}
        saving={saving}
        errors={errors}
        submitButtonText="Add Friend"
      />
    </div>
  );
};
